export interface StoredUser {
  email?: string;
  firstname?: string;
  lastname?: string;
  groups?: string;
  [key: string]: unknown;
}

export interface AuthSession {
  jwt: string;
  user: StoredUser;
}

export const getStoredJwt = () => localStorage.getItem('jwt');

export const getStoredUser = (): StoredUser => {
  try {
    return JSON.parse(localStorage.getItem('user') || '{}');
  } catch (error) {
    return {};
  }
};

export const getStoredUserEmail = () => {
  const user = getStoredUser();
  return typeof user.email === 'string' ? user.email : '';
};

export const getStoredRoles = () => {
  const user = getStoredUser();

  try {
    return JSON.parse(typeof user.groups === 'string' ? user.groups : '[]');
  } catch (error) {
    return [];
  }
};

export const storeSession = ({ jwt, user }: AuthSession) => {
  localStorage.setItem('jwt', jwt);
  localStorage.setItem('user', JSON.stringify(user));
};

export const clearSession = () => {
  localStorage.clear();
};

export const isExpiredTokenResponse = (data: unknown) =>
  data === 'Error decoding token: Expired token';
